import React, { PureComponent } from 'react';
import { View, Image } from 'react-native';
import { SoundManager } from "../../../assets/soundManager2";
import Loader from 'react-loader-spinner'
import { connect } from "react-redux";

import { SquareButton, SquareButtonRed, CircleButton, CaptionNormalLight, InputWithButton } from "../../../components";
import styles from "../../../styles";
import { audioToBase64, onException } from '../../../functions';
import { global, action } from '../../../const';

import SendIcon from '../../../assets/icon/send_white.png';
import AudioIcon from '../../../assets/icon/mic_ic.png';
import StopIcon from "../../../assets/icon/stop_ic.png";
import play_ic from "../../../assets/ic_120/play_white_icn.png";
import pause_ic from "../../../assets/ic_120/pause_white_icn.png";
import Remove_blue from "../../../assets/ic_120/Remove_blue.png";
import Remove_gray from "../../../assets/ic_120/Remove_gray.png";
import createSoundWave from '../../../functions/createSoundWave';
import localize from '../../../localize';


window.MediaRecorder = window.MediaRecorder ? window.MediaRecorder : require('audio-recorder-polyfill')
window.AudioContext = (window.AudioContext || window.webkitAudioContext)

let recorder = null;
let mediaStream = null;
let context = null;
let mediaRecorder = null;

const soundManager = new SoundManager();

class MessageInput extends PureComponent {

    SoundObject = soundManager.createSound()

    constructor() {
        super()
        this.state = {
            textMessage: '',
            duration: 0,
            playTimer: 0,
            isRecording: false,
            recordTimer: 0,
            VoiceBase64: null
        }
        window.ReactAudioRecorder = this;   // for native ios audio receive
    }

    onAudioplay = () => {
        if (this.SoundObject.playState === 1) return this.SoundObject.stop()
        soundManager.stopAll();
        this.SoundObject.play()
    }

    onTextMessageSend = () => {
        this.props.onsendGroupMessage({ type: 0, message: this.state.textMessage })
        return this.setState({ textMessage: '' });
    }

    onsendVoiceMessage = () => {
        const { duration, VoiceBase64 } = this.state;
        this.props.onsendGroupMessage({ type: 2, message: duration + '^data:audio/mp3;base64,' + VoiceBase64 })
        return this.onDeleteRecordedVoice();
    }

    render() {
        const { isRecording, VoiceBase64, textMessage, recordTimer } = this.state;

        return (
            <View style={{ bottom: 8, paddingHorizontal: 10, position: 'relative', width: '100%', backgroundColor: 'transparent' }}>

                {
                    isRecording === false && VoiceBase64 === null ?
                        <InputWithButton
                            placeholder="Type a message..."
                            onChange={(value) => this.setState({ textMessage: value })}
                            value={textMessage}
                            style={[styles.borderGrey]}
                            onSubmitEditing={this.onTextMessageSend}
                            rightComponent={(
                                <View style={{ marginRight: 5 }}>
                                    <SquareButton
                                        component={(
                                            <Image style={{ width: 20, height: 20 }} resizeMode="contain" source={textMessage !== "" ? SendIcon : AudioIcon} />
                                        )}
                                        onPress={textMessage !== "" ? this.onTextMessageSend : this.onVoiceRecording}
                                    />
                                </View>
                            )}
                        /> :

                        <View style={[styles.inputField, styles.borderGrey, { paddingHorizontal: 5, justifyContent: 'space-between' }]}>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                {
                                    VoiceBase64 !== null ?
                                        <View style={[styles.recordingTimer, styles.bgBlue]}>

                                            <Image
                                                source={this.SoundObject.playState === 1 ? pause_ic : play_ic}
                                                style={{ width: 28, height: 28, margin: 5 }}
                                                onClick={this.onAudioplay}
                                                resizeMode="contain" />

                                            <View style={{ marginHorizontal: 10, width: 100 }}>
                                                <canvas height="40" id="msgWave"></canvas>
                                            </View>

                                            <CaptionNormalLight title={this.SoundObject.playState === 1 ? this.state.playTimer : this.state.duration} />
                                        </View>
                                        :
                                        <View style={[styles.recordingTimer, styles.bgDisabled]}>
                                            <Image source={play_ic} style={{ width: 28, height: 28, margin: 5 }} resizeMode="contain" />
                                            <View style={{ marginHorizontal: 10, flexDirection: 'row' }}>
                                                <Loader type="Bars" color="#fff " height={28} width={28} />
                                                <Loader type="Bars" color="#fff " height={28} width={28} />
                                            </View>
                                            <CaptionNormalLight title={recordTimer} />
                                        </View>
                                }
                                {
                                    <CircleButton
                                        component={(<Image source={isRecording ? Remove_gray : Remove_blue} style={{ height: 30, width: 30 }} resizeMode="contain" />)}
                                        onPress={isRecording ? () => null : this.onDeleteRecordedVoice}
                                    />
                                }
                            </View>
                            <View>

                                <SquareButtonRed
                                    component={(
                                        <Image style={{ width: 20, height: 20 }} resizeMode="contain" source={VoiceBase64 === null ? StopIcon : SendIcon} />
                                    )}
                                    onPress={VoiceBase64 === null ? this.stopVoiceRecording : this.onsendVoiceMessage}
                                />


                            </View>
                        </View>

                }

            </View>
        )
    }

    // Do not change function name. it's receive native voicebase64 from webview
    onReceiveAudio = (VoiceBase64) => {
        this.setState({ VoiceBase64, playTimer: this.state.recordTimer, duration: this.state.recordTimer });
        let context = document.getElementById("msgWave");
        if (context !== null) {
            context = context.getContext('2d');
            createSoundWave('data:audio/mp3;base64,' + VoiceBase64, context, { color: '#fff', barLines: 100 });
        }
        return this.intilizeSoundManager();
    }

    onDeleteRecordedVoice = () => {
        if (this.SoundObject.playState === 1) this.SoundObject.stop()
        if (this.state.isRecording) this.stopVoiceRecording()
        return this.setState({ VoiceBase64: null, isRecording: false });
    }

    onVoiceRecording = () => {

        if (window.webkit && window.wv) {
            this.setState({ recordTimer: 0 })
            this.recordProgress = setInterval(() => {
                this.setState({ recordTimer: this.state.recordTimer + 1 })
                if (this.state.recordTimer === 60) this.stopRecording()
            }, 1000);
            window.webkit.messageHandlers.showMessage.postMessage(['3', '2', '1']);
            this.setState({ isRecording: true });
            return true;
        }

        if (!navigator.mediaDevices) {
            window.location = "itms-apps://itunes.apple.com/us/app/daily-vitals-powered-by-woogi/id1463546063"
            return this.props.showNotification("error", "Browser doesn't support medieDevice!");
        }
        soundManager.stopAll();
        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
            .then((stream) => {
                window.streamReference = stream;
                mediaRecorder = new MediaRecorder(stream);
                mediaRecorder.start();
                context = new AudioContext();
                mediaStream = context.createMediaStreamSource(stream);
                if (context.createScriptProcessor) {
                    recorder = context.createScriptProcessor(4096, 1, 1);
                } else {
                    recorder = context.createJavaScriptNode(4096, 1, 1);
                }
                const audioChunks = [];
                mediaRecorder.addEventListener("dataavailable", event => audioChunks.push(event.data));

                mediaRecorder.addEventListener("stop", async () => {
                    const audioBlob = new Blob(audioChunks);
                    let base64 = await audioToBase64(audioBlob);
                    this.onReceiveAudio(base64);
                    return this.setState({ isRecording: false });
                });
                mediaStream.connect(recorder);
                recorder.connect(context.destination);
                recorder.onaudioprocess = (e) => {
                    this.setState({ recordTimer: (e.playbackTime | 0), isRecording: true })
                    if ((e.playbackTime | 0) === 60) this.stopRecording()
                };
            })
            .catch((error) => {
                onException(error);
                this.props.showNotification("error", localize.No_recording_device_found);
            })
    }

    stopVoiceRecording = () => {
        try {
            if (window.webkit && window.wv) {
                clearInterval(this.recordProgress);
                window.webkit.messageHandlers.showMessage.postMessage(['3', '2', '0']);
                this.setState({ isRecording: false });
                return true;
            }
            recorder.disconnect(context.destination);
            mediaStream.disconnect(recorder);
            mediaRecorder.stop();
            if (!window.streamReference) return;
            window.streamReference.getAudioTracks().forEach((track) => {
                return track.stop();
            });
            return window.streamReference = null;
        } catch (error) {
            onException(error)
        }
    }

    intilizeSoundManager = () => {
        this.SoundObject = soundManager.createSound({
            id: global.database_ + 'ctm_player',
            url: 'data:audio/mp3;base64,' + this.state.VoiceBase64,
            autoLoad: true,

            whileplaying: () => {
                let playTimer = this.state.duration - ((this.SoundObject.position / 1000.0) | 0);
                this.setState({ playTimer })
                let curDuration = ((this.SoundObject.duration / 1000.0) | 0);
                if (curDuration !== this.state.duration && curDuration !== 0) {
                    this.setState({ duration: curDuration })
                }
            },

            onfinish: () => this.setState({ playTimer: ((this.SoundObject.duration / 1000.0) | 0) }),

            onstop: () => this.setState({ playTimer: this.state.duration }),

            onerror: () => {
                console.error("Voice Message is not valid")
                this.onDeleteRecordedVoice();
            }

        })

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (variant, message) => dispatch({ type: action.open_notification, message, variant })
    };
};

export default connect(null, mapDispatchToProps)(MessageInput);